module.exports = __webpack_public_path__ + "static/media/print-past.289a4fb7.svg";